export const toBlogTags = (value) =>
  Array.isArray(value)
    ? value.map((item) => String(item).trim()).filter(Boolean)
    : typeof value === "string"
      ? value.split(",").map((item) => item.trim()).filter(Boolean)
      : [];

export function normalizeBlogSlug(slug) {
  if (!slug || typeof slug !== "string") return "";

  let value = slug.trim();
  if (!value) return "";

  try {
    while (/%[0-9A-Fa-f]{2}/.test(value)) {
      const decoded = decodeURIComponent(value);
      if (decoded === value) break;
      value = decoded;
    }
  } catch {
    // Keep original when decode fails
  }

  return value;
}

export function isNumericBlogParam(value) {
  return /^\d+$/.test(String(value || "").trim());
}

export function slugifyBlogTitle(title) {
  return String(title || "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

/** Public blog URL uses slug/tag/title — never numeric id. */
export const getBlogPostPathSegment = (post) => {
  const tag = toBlogTags(post?.tags).find(
    (item) => item && !isNumericBlogParam(item),
  );
  const slug =
    post?.slug && !isNumericBlogParam(post.slug)
      ? String(post.slug).trim()
      : "";
  const value = tag || slug || slugifyBlogTitle(post?.title);
  if (!value || isNumericBlogParam(value)) return "";
  return value;
};

export const getBlogPostHref = (post) => {
  const slug = getBlogPostPathSegment(post);
  return slug ? `/blog/${encodeURIComponent(slug)}` : "";
};

export function extractBlogPosts(response) {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.blogs)) return response.blogs;
  if (Array.isArray(response.posts)) return response.posts;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data?.blogs)) return response.data.blogs;
  return [];
}
